<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">“星火·链网”第五批骨干节点建设评审会顺利召开</h1>
                    <div class="title-info">2021-09-16</div>
                    <div class="main-content">
                        <p>
	2021年9月15日，由中关村区块链产业联盟(以下简称“ABI”)组织召开的“星火·链网”第五批骨干节点建设评审会议顺利召开，本次会议主要评审了广东佛山和珠海横琴两个骨干节点的建设方案。来自中国信息通信研究院(以下简称“中国信通院”)、北京航空航天大学、中兴、华为、布比、联通、中微汇链、溪塔科技等科研院所及行业领先企业的技术专家参与了本次评审工作。广东省通信管理局副处长陈逸菁线上出席会议并致辞，广州市工业和信息化局二级调研员张凯军、佛山市工业和信息化局科长刘亚云线上出席了本次会议。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<img src="/core/extend/kindeditor/attached/image/20220228/20220228173906_90263.jpg" alt="" ondragstart="return false"> 
</p>
<p>
	<br>
</p>
<p>
	陈逸菁在致辞中提到，区块链技术是产业数字化转型的重要组成部分。希望在中国信通院技术标准、规范制定等方面发挥行业研究优势的引领下，构建基于标识解析体系的区块链新型基础设施，通过提供标识分配、标识管理等基础服务，发挥区块链技术在优化业务流程、降低运营成本、建设可信体系、降低重点领域安全风险、落实企业主体责任等方面的重要作用，进一步推动应用场景落地，规范运营管理体系，打造基于区块链技术的工业互联网新模式、新业态，创造的更大的经济效益和社会效益。
</p>
<p>
	<br>
</p>
<p>
	会上，中国信通院工业互联网与物联网研究所副所长罗松向关注和支持“星火·链网”发展的各方表示感谢。他指出，“星火·链网”作为国家级区块链新型基础设施，致力于在技术革新和产业变革中发挥重要作用，进一步推动工业互联网迅速发展，加速我国区块链新型基础设施的建设和布局。“星火·链网”将在数字金融、智能制造、工业互联网、供应链管理等多个领域提供基于数字身份和区块链技术的一体化解决方案，以降低整个经济社会运行的信用成本，推动数据要素更加高效合理配置，为行业数字化转型带来新模式。同时，希望参与骨干节点建设的建设方和运营方对骨干节点建设模式、运营模式、商业模式深入设计和思考，从而更加有效有序推动地“星火·链网”区块链新型基础设施的建设和发展。
</p>
<p>
	<br>
</p>
<p>
	中国信通院工业互联网与物联网研究所马超向参评单位及评审专家详细介绍了“星火·链网”骨干节点的建设流程及评审要求。广州赛意信息科技股份有限公司与珠海横琴融贯国际科技发展公司负责人分别报告了“星火·链网”(佛山市)骨干节点和“星火·链网”(珠海横琴)骨干节点建设方案。
</p>
<p>
	<br>
</p>
<p>
	评审专家对两个“星火·链网”骨干节点建设方案均给予较高的评价，希望两个骨干节点在建设与发展过程中能够进一步考虑如何结合产业优势在同一个大的区域内协同发展，并且在后续的运营及应用培育中，继续探索、创新，真正成为“星火·链网”应用生态的创新示范。
</p>
<p>
	<br>
</p>
<p>
	“星火·链网”(佛山市)骨干节点是由广州赛意科技股份有限公司作为主体，北京泰尔英福科技有限公司提供区块链技术支持，立足佛山市数字经济发展目标而设计建设及运营。致力于通过加速佛山区块链产业聚集、带动制造业数字化转型，实现跨行业信息共享和数据沉淀，助推当地企业互联网化进程和数字化改造建设，进一步夯实佛山市经济社会高质量发展基础，以新型基础设施支撑传统产业的数字化转型，实现融合基础设施在推动佛山市数字经济发展的引擎作用。
</p>
<p>
	<br>
</p>
<p>
	&emsp;&emsp;“星火·链网”(珠海横琴)骨干节点是由广东云湾工业互联网有限公司作为建设主体，由珠海横琴融贯国际科技发展公司作为运营主体，依托浪潮集团及北京泰尔英福科技有限公司的区块链技术而设计的。该骨干节点基于“星火·链网”的建设要求，面向粤港澳各行业提供稳定的区块链和标识解析等服务，通过区块链资源分配和管理、标识注册及解析服务、信息系统建设和运营、服务应用对接和推广等工作，提高区块链在不同场景中的应用能力，构建以标识为媒介的信息互联互通机制，实现数据开放和共享，为粤港澳大湾区深度合作区提供一个可信的数据基础设施。
</p>
<p>
	<br>
</p>
<p>
	ABI将继续在中国信通院的委托授权下组织开展骨干节点建设方案的评审评估工作，围绕“星火·链网”建设与产业化应用实践，不断凝聚共识、扩大共识，促进工业互联网等广泛典型应用场景的全要素、全产业链、全价值链互联互通，加速培育数字经济的新生态体系。
</p>
<p>
	<br>
</p>
<p>
	“星火·链网”简介
</p>
<p>
	<br>
</p>
<p>
	“星火·链网”是在工信部的领导与专项支持下，由中国信通院牵头、联合北航、北邮、中国联通等多家大型企事业单位建设的国家区块链新型融合基础设施体系。是为持续推进产业数字化转型，推动数字资产价值化，利用区块链自主创新能力而谋划布局的数字经济“新型基础设施”；其以代表产业数字化转型的工业互联网为主要应用场景，以网络标识这一数字化关键资源为突破口，推动区块链的应用发展，实现新基建的引擎作用。“星火·链网”建设策略及治理模式开放，定位于面向全球服务的国家级区块链新型基础设施，2020年8月正式启动部署。2021年8月3日，中国信通院正式发布了“星火·链网”底层区块链系统(BIF-Core)，标志“星火·链网”主链正式启动运行并开始向全球进行服务。
</p>
<p>
	<br>
</p>
<p>
	“星火·链网”骨干节点是整个“星火·链网”双层体系架构中锚定对接超级节点主链与行业/区域链的一类关键角色，目前采用产业力量主导的“开放生态建设”原则和发展模式。
</p>
<p>
	<br>
</p>
<p>
	“中关村区块链产业联盟”简介
</p>
<p>
	<br>
</p>
<p>
	中关村区块链产业联盟(Alliance of Blockchain Industry，Z-park；简称：ABI)定位于“以区块链为核心的新型基础设施建设与应用协同创新的推动者、实践者”，致力于推动区块链技术与产业应用的融合创新发展。一方面，依托联盟汇聚政产学研用等各方力量，发挥联盟技术专家委员会的高层次、专业化咨询指导作用，更加开放性、广泛性、更深层次的凝聚产业共识；另一方面，依托联盟开放创新平台更好地推动国家区块链基础设施在各区域的落地建设与产业化应用，不断促进区块链技术服务于实体经济创新应用。中关村区块链产业联盟受中国信息通信研究院委托，负责组织开展骨干节点建设方案的评审评估工作。
</p>
<p>
	<br>
</p>
<p>
	来源：中国新闻网
</p>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/93" ondragstart="return false">上一条 :  澳门融贯受邀出席第四届中国—蒙古国博览会第二届中蒙国际标准化论坛</a>
                        <a href="javascript:;" ondragstart="return false">下一条 : 没有了！</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>